<template>
  <v-card class="ma-5">


    <v-card-text class="d-flex flex-column align-center text-center ">
      <v-img height="100" width="100" :src="Logo" class="bg-grey-lighten-2  rounded pa-0 ma-4 mb-0" />


      <!-- <div class="text-body-medium font-weight-light ma-2 text-grey-darken-1">data collector</div> -->

      <h1 class="text-headline-large font-weight-bold mt-4">Picker</h1>
      <h2 class="text-headline-small font-weight-bold text-grey">Parco&nbsp;Nazionale&nbsp;<wbr />del&nbsp;Gran&nbsp;Paradiso</h2>

      <h2 v-if="ENVIRONMENT != 'production'" class="text-headline-small font-italic font-weight-bold text-lime-darken-3">{{ ENVIRONMENT }}</h2>
      <div class="mx-5 my-3 text-body-medium	 text-left text-grey-darken-3">
        <pre>package: {{ npmlist.version }}</pre>
        <pre>commit: {{ VERSION }}</pre>
        <pre>build time: {{ bt_ita }}</pre>
        <pre>running: {{ runningHumanReadable }}</pre>
        <pre>uptime: {{ upHumanReadable }}</pre>
        <!-- running: {{ runTimeStore.runningTime }}<br>
        uptime: {{ runTimeStore.upTime }}<br> -->
      </div>

      <v-row class="d-flex align-center justify-center pt-5">
        <v-col cols="auto">
          <strong>Descrizione</strong><br>
          <div class="text-left" style="max-width:50em">
            Applicazione per la raccolta dati in campo.<br>
            <span class="d-block pt-1">
              Funzionalità principali:
            </span>
            <ul class="pl-6 pb-1">
              <li>consultazione mappe raster e vettoriali</li>
              <li>raccolta e trasferimento dati e media</li>
            </ul>
            <span class="d-block pt-1">
              Caratteristiche:
            </span>
            <ul class="pl-6 pb-1">
              <li>PWA</li>
              <li>cross-platform</li>
              <li>utilizzo in modalità offline</li>
              <li>accesso alla sensoristica del dispositivo: fotocamera, microfono, posizione</li>
            </ul>
            Aggiornamento continuo.<br>
          </div>
          <p class="ma-3 mt-6">
            <strong>Hanno partecipato</strong><br>
            Cerise&nbsp;Stefano,
            Bracotto&nbsp;Giovanni,
            Peracino&nbsp;Alberto, <br>
            Renzo&nbsp;Guglielmetti,
            Poggio&nbsp;Laura,
            Mainetti&nbsp;Andrea<br>
            <br>
            <strong>Immagini</strong><br>
            Massa&nbsp;Micon&nbsp;Enzo, Fototeca<br>
            <br>
            <strong>Realizzazione</strong><br>
            Milone&nbsp;Marco<br>
          </p>
        </v-col>
      </v-row>

    </v-card-text>


    
    <v-img :height="200" cover :src="InstallImage"></v-img>
    <p class="text-center pa-1 bg-blue-grey">
      <acronym title="Parco Nazionale del Gran Paradiso" class="text-decoration-none">PNGP</acronym>
       Picker 2015 - {{ year }}</p>


    <div v-if="ENVIRONMENT === 'development'">
      <v-divider />
      <v-card-text class="d-flex flex-column align-center text-center px-6">
        <strong>Dipendenze</strong><br>
        <pre class="text-left">{{ npmlistcleaned }}</pre>
        <!-- <pre class="text-left">{{ npmlist }}</pre> -->
      </v-card-text>
    </div>
  </v-card>
</template>

<script setup>
import { computed } from "vue"
import Logo from "/img/icons/icon.png"

import { useRuntimeStore } from "@/store/runtime"

import npmlist from '@/assets/json/npm.list.json'
import InstallImage from "@/assets/img/install.jpg";


const runTimeStore = useRuntimeStore()

const runningHumanReadable = computed(() => {

  const days = Math.floor(runTimeStore.runningTime / (1000 * 60 * 60 * 24))
  const hours = String(Math.floor((runTimeStore.runningTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0')
  const minutes = String(Math.floor((runTimeStore.runningTime % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
  const seconds = String(Math.floor((runTimeStore.runningTime % (1000 * 60)) / 1000)).padStart(2, '0')

  return `${days}d ${hours}h ${minutes}m ${seconds}s`
})
const upHumanReadable = computed(() => {

  const days = Math.floor(runTimeStore.upTime / (1000 * 60 * 60 * 24))
  const hours = String(Math.floor((runTimeStore.upTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0')
  const minutes = String(Math.floor((runTimeStore.upTime % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
  const seconds = String(Math.floor((runTimeStore.upTime % (1000 * 60)) / 1000)).padStart(2, '0')

  return `${days}d ${hours}h ${minutes}m ${seconds}s`
})

// import Logo from "@/assets/img/logo.png";


const bt_ita = new Date(BUILD_TIMESTAMP).toLocaleString('it-IT', { timeZone: 'Europe/Rome' })
// const commit = date.toISOString().slice(0, 19)
const year = new Date().getFullYear()


// console.log(npmlist.dependencies)

const npmlistcleaned = Object.entries(npmlist.dependencies).map(([key, value]) => {
  return key + ": " + value.version
})

// console.log(npmobjcleaned)



</script>
